import React from 'react';
import { useForm, Controller, FieldError } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { StepContainer } from '../../components/StepContainer/StepContainer';
import { StepFooter } from '../../components/StepFooter/StepFooter';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { FormValues, STEP_ID, validation } from './CharityName.meta';
import { INPUTS_WIDTH } from '../../CharitableGiving.meta';
import { useNavigation } from '../../hooks/useNavigation';
import { WorkflowDTO } from '../../api/useCharitableGivingQuery';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

export const CharityName = () => {
  const { workflow, setWorkflow, setStep } = useCharitableGivingContext();

  const { progress, previousStep, nextStep, isFirstStep } = useNavigation({ currentStep: STEP_ID });

  const {
    options: { charityNameOptions },
  } = workflow;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      charityName: workflow.data.charityName
        ? { label: workflow.data.charityName, value: workflow.data.charityName }
        : null,
    },
    resolver: yupResolver(validation),
  });

  const onSubmit = handleSubmit(values => {
    const newWorkflow: WorkflowDTO = {
      ...workflow,
      data: {
        ...workflow.data,
        charityName: values.charityName?.value || null,
      },
    };

    setWorkflow(newWorkflow);

    if (nextStep) {
      setStep(nextStep);
    }
  });

  return (
    <StepContainer
      title="What is the charity name?"
      onSubmit={onSubmit}
      footer={
        <StepFooter
          isFirstStep={isFirstStep}
          progress={progress}
          onPrevious={previousStep ? () => setStep(previousStep) : undefined}
        />
      }
    >
      <Box style={{ width: INPUTS_WIDTH }}>
        <Controller
          control={control}
          name="charityName"
          render={({ field: { value, onChange } }) => {
            return (
              <>
                <Select
                  isCreatable
                  isPortal
                  isClearable
                  value={value}
                  options={charityNameOptions}
                  onChange={opt => {
                    onChange(opt);
                  }}
                  onCreateOption={opt => {
                    if (opt) {
                      onChange({ label: opt, value: opt });
                    }
                  }}
                  aria-label="Select or add a Charity"
                  label="Select or add a Charity"
                  placeholder="Select or add a Charity"
                  noOptionsMessage={() => 'Please enter a charity name'}
                  formatCreateLabel={createValue => `Add ${createValue}`}
                  formVariant={errors.charityName ? 'error' : undefined}
                  helperText={(errors.charityName as FieldError)?.message}
                />
              </>
            );
          }}
        />
      </Box>
    </StepContainer>
  );
};
